export const numberInputOnWheelPreventChange = e => {
  e.target.blur();
};
